<ag-grid-angular
  [style.height.px]="component.element.gridHeight || 500"
  style="width: 100%;"
  class="ag-theme-alpine"
  [rowData]="component.element.rowData"
  [columnDefs]="component.element.columnDefs" (gridReady)="onGridReady($event)" [gridOptions]="gridOptions" [components]="component.element.frameworkComponents"
  >
</ag-grid-angular>
